import Component from '../core/Component.js'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const defaults = {
    cellSelector: '[data-ref="item"]',
    prevNextButtons: false,
    pageDots: false,
    contain: true,
    autoplay: false,
    lazyLoad: true,
    responzive: true,
    resize: true,
}

export const STATUS = {
    READY: 'is-ready',
    DISABLED: 'is-disabled'
}

export default class BlogSlider extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            slider: null,
            items: [],
        }

        let options = {}

        if (this.element.dataset.options) {
            options = JSON.parse(this.element.dataset.options || '') || {}
        }

        this.options = {
            ...defaults,
            ...options,
        }

        this.flickity = null

        this.enquireHandler = {
            match: ::this.match,
            unmatch: ::this.unmatch
        }
    }

    prepare() {
        if (this.ref.items.length > 1) {
            enquire.register(queries.smallWideMax, this.enquireHandler)
        }
    }

    destroy() {
        enquire.unregister(queries.smallWideMax, this.enquireHandler)
    }

    match() {
        if (this.ref.items.length > 1) {
            this.element.classList.add(STATUS.READY)
            this.flickity = new Flickity(this.ref.slider, this.options)
        }
    }

    unmatch() {
        this.element.classList.remove(STATUS.READY)
        this.flickity.destroy()
    }
}